import * as React from "react";
import "@splidejs/react-splide/css/core";
import {Splide, SplideTrack, SplideSlide} from "@splidejs/react-splide";

import Icon from "../../../icon/Icon";

import CardCarouselArrowIcon from "/src/svg/card-carousel-arrow.svg";

import {css} from "/src/utils/utils";

import * as styles from "./mobile-loop-carousel.module.scss";

interface Props<SlideType> {
  children: (slide: SlideType, index: number) => React.ReactNode;
  slides: ReadonlyArray<SlideType>;
  onCurrentSlideChange: (newIndex: number, prevIndex: number) => void;
  selectedSlideIndex?: number;
}

const SPLIDE_OPTIONS = {
  perPage: 1,
  rewind: true,
};

export function MobileLoopCarousel<SlideType>(props: Props<SlideType>) {
  const {children, onCurrentSlideChange, slides, selectedSlideIndex} = props;
  const splideInstanceRef = React.useRef<Splide | null>(null);

  const handleMoved = React.useCallback(
    (_: any, index: number, prev: number) => {
      onCurrentSlideChange(index, prev);
    },
    [onCurrentSlideChange]
  );

  React.useEffect(() => {
    if (
      selectedSlideIndex != null &&
      splideInstanceRef.current?.splide &&
      splideInstanceRef.current.splide.index !== selectedSlideIndex
    ) {
      splideInstanceRef.current.splide.go(selectedSlideIndex);
    }
  }, [selectedSlideIndex]);

  if (!slides) {
    return null;
  }

  return (
    <Splide
      ref={splideInstanceRef}
      hasTrack={false}
      options={SPLIDE_OPTIONS}
      onMoved={handleMoved}
      className={styles.mobileLoopCarousel}
    >
      <SplideTrack>
        {slides.map((slide, index) => (
          <SplideSlide key={index} className={styles.mobileLoopCarousel__slide}>
            {children(slide, index)}
          </SplideSlide>
        ))}
      </SplideTrack>
      <div className={styles.mobileLoopCarousel__actions}>
        <div className="splide__arrows">
          <button
            type="button"
            className={css(
              styles.mobileLoopCarousel__actions__arrow,
              styles.mobileLoopCarousel__actions__arrowPrev,
              "splide__arrow splide__arrow--prev"
            )}
          >
            <Icon
              classes={styles.mobileLoopCarousel__actions__arrowIcon}
              svg={CardCarouselArrowIcon}
              role="presentation"
            />
          </button>

          <button
            type="button"
            className={css(
              styles.mobileLoopCarousel__actions__arrow,
              styles.mobileLoopCarousel__actions__arrowNext,
              "splide__arrow splide__arrow--next"
            )}
          >
            <Icon
              classes={styles.mobileLoopCarousel__actions__arrowIcon}
              svg={CardCarouselArrowIcon}
              role="presentation"
            />
          </button>
        </div>
        <ul
          className={css(
            styles.mobileLoopCarousel__actions__pagination,
            "splide__pagination"
          )}
        />
      </div>
    </Splide>
  );
}
